<template>
  <div class="ui-accordion">
    <div class="ui-accordion__trigger" @click="closed = !closed">
      <div class="ui-accordion__title">{{ title }}</div>
      <Badge v-if="counter" color="light-blue" contrast rounded>{{ counter }}</Badge>
      <Icon
        :key="closed"
        :type="closed ? 'chevron-down' : 'chevron-up'"
        color="secondary"
        size="16"
        class="ml-auto"
      />
    </div>
    <div v-if="!closed && content" class="ui-accordion__content spacey-8">
      <Checkbox
        v-for="elem in content"
        :key="elem.id"
        :checked="selectedElementIds.includes(elem.id)"
        @check="$emit('check', { value: $event, id: elem.id })"
      >
        {{ elem.number }}. {{ elem.title }}
      </Checkbox>
    </div>
  </div>
</template>

<script>
  import Badge from '@/components/ui/Badge';
  import Icon from '@/components/ui/Icon';
  import Checkbox from '@/components/ui/Checkbox';
  export default {
    name: 'Accordion',
    components: { Checkbox, Icon, Badge },
    props: {
      title: {
        type: String,
        required: true,
      },
      counter: {
        type: Number,
        default: 0,
      },
      content: {
        type: [Array, Object],
        default: null,
      },
      selectedElementIds: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        closed: false,
      };
    },
  };
</script>
<style lang="scss">
  @import 'src/styles/components/accordion';
</style>
